import { executeGet, executePut } from '../common/apiCaller'
import {
  GetChildrenFebrileSeizureDto,
  PutChildrenFebrileSeizureInputDto,
} from '../dto/childrenFebrileSeizureDto'

const apiName = 'public'
const apiPath = '/children-febrile-seizure'

// 予防接種情報取得
export const executeGetChildrenFebrileSeizure = (id: string, facilityId: string) => {
  return executeGet<GetChildrenFebrileSeizureDto[]>(apiName, `${apiPath}/${id}`, { facilityId })
}

// 予防接種情報登録
export const executePutChildrenFebrileSeizure = (id: string, input: PutChildrenFebrileSeizureInputDto) => {
  return executePut<null>(apiName, `${apiPath}/${id}`, input)
}